/**
 * Rules engine registry — SPEC 4.9.
 *
 * Each rule is a self-contained pure function. The runtime in `engine.ts`
 * calls `evaluate(ctx)` per rule and returns the firings. New rules are added
 * by importing them here.
 */
import type { Rule } from "./types";

import { hrvDrop3dBelowBaseline } from "./recovery/hrv-drop-3d";
import { rhrElevated3d } from "./recovery/rhr-elevated-3d";
import { sleepDebt2Nights } from "./recovery/sleep-debt";
import { sleepWindowDrift } from "./recovery/sleep-window-drift";
import { coldPostStrengthViolation } from "./recovery/cold-post-strength";
import { illnessSymptomsRecent } from "./recovery/illness-symptoms";
import { acuteChronicLoadSpike } from "./training/acute-chronic-load";
import { polarizedRatioOff } from "./training/polarized-ratio";
import { noZ2In7Days } from "./training/no-z2-7d";
import { creatineSkippedToday } from "./nutrition/creatine-missed";
import { supplementStreakBreak } from "./nutrition/supplement-streak-break";
import { tirzepatideDoseDue } from "./nutrition/tirzepatide-dose-due";
import { kcalBelowFloor } from "./nutrition/kcal-floor";
import { pantryExpired, pantryUseToday } from "./nutrition/pantry-expired";
import { vitDRecheckDue } from "./body/vit-d-recheck";
import { apobAboveTarget } from "./body/apob-target";
import { documentExpiringSoon } from "./identity/document-expiring";

export const RULES: Rule[] = [
  hrvDrop3dBelowBaseline,
  rhrElevated3d,
  sleepDebt2Nights,
  sleepWindowDrift,
  coldPostStrengthViolation,
  illnessSymptomsRecent,
  acuteChronicLoadSpike,
  polarizedRatioOff,
  noZ2In7Days,
  creatineSkippedToday,
  supplementStreakBreak,
  tirzepatideDoseDue,
  kcalBelowFloor,
  pantryExpired,
  pantryUseToday,
  vitDRecheckDue,
  apobAboveTarget,
  documentExpiringSoon,
];

export type { Rule, RuleContext, RuleFiring, RuleSeverity } from "./types";
export { runRules } from "./engine";
